<template>
  <div class="stateStatisticsHistory">
    <div class="management-search">
      <div class="management-search-1">
        日期：
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="startDate"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          format="YYYY-MM-DD"
          placeholder="结束时间"
          v-model="endDate"
        />
      </div>
      <div class="management-search-1">
        平台：
        <a-select
          v-model="platformId"
          placeholder="请选择平台"
          class="select-tag"
          allowClear
          @change="query(1)"
        >
          <a-select-option
            v-for="(item, index) in platformSelectList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        状态：
        <a-select
          v-model="status"
          placeholder="请选择状态"
          class="select-tag"
          allowClear
          @change="query(1)"
        >
          <a-select-option
            v-for="(item, index) in statusList"
            :key="item.index"
            :value="item.code"
            >{{ item.desc }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div class="userList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="count" slot-scope="text, record">
        {{ text }}
        <a-tooltip
          placement="topLeft"
          v-if="
            (record.status == 'PRE_CHECK_FAIL' ||
              record.status == 'PLATFORM_CHECK_FAIL') &&
            record.remark
          "
        >
          <template slot="title">
            <template v-for="item in record.remark">
              <span>{{ item.reason }} : {{ item.count }} | {{ item.rate }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
    </a-table>
  </div>
</template>
<script>
import api from "../lib/stateStatistics.js";

export default {
  name: "stateStatisticsHistory",
  data() {
    return {
      startDate: null,
      endDate: null,
      platformId: undefined,
      platformIdAdd: undefined,
      status: undefined,
      loading: false,
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "日期",
          dataIndex: "date",
        },
        {
          title: "平台",
          dataIndex: "platform",
        },
        {
          title: "状态",
          dataIndex: "statusLabel",
        },
        {
          title: "数量",
          dataIndex: "count",
          scopedSlots: { customRender: "count" },
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      platformSelectList: [],
      statusList: [],
    };
  },
  computed: {
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endDate) {
        return this.$common.dayFormat(this.endDate);
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startDate) {
        return this.$common.dayFormat(this.startDate);
      }
      return "";
    },
  },
  mounted() {
    this.getPlatformSelectList();
    this.getStatusList();
    this.query(1);
  },
  methods: {
    getStatusList() {
      api.qualificationStatus().then((res) => {
        if (res.result == 200) {
          this.statusList = res.data;
        }
      });
    },
    getPlatformSelectList() {
      api.platformSelectList().then((res) => {
        if (res.result == 200) {
          this.platformSelectList = res.data;
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        pageNo: this.pageNo,
        pageSize: 10,
        platformId: this.platformId,
        status: this.status,
        startDate: this.lastLoginDateStartTime,
        endDate: this.lastLoginDateEndTime,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data.records;
            this.tableDataSource = list;
            this.tableDataSource.forEach((item) => {
              this.statusList.forEach((status) => {
                if (item.status == status.code) {
                  this.$set(item, "statusLabel", status.desc);
                }
              });
              if (item.remark) {
                this.$set(item, "remark", JSON.parse(item.remark));
              }
            });
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    // 翻页
    changePageItem(index) {
      this.query(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.stateStatisticsHistory {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
}
</style>
